import { render, staticRenderFns } from "./modalGrocerySort.vue?vue&type=template&id=f3d30810&scoped=true&"
import script from "./modalGrocerySort.vue?vue&type=script&lang=js&"
export * from "./modalGrocerySort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3d30810",
  null
  
)

export default component.exports